(function () {
  'use strict';
  let active = null, openTimer = null, closeTimer = null;
  function button(item) { return item.querySelector('.jb-menu-toggle'); }
  function panel(item) { return item.querySelector('.jb-menu-panel'); }
  function position(item) {
    const nav = item.closest('nav');
    const rect = item.getBoundingClientRect();
    panel(item).style.setProperty('--jb-compact-center', Math.max(204, Math.min(window.innerWidth - 204, rect.left + rect.width / 2)) + 'px');
    panel(item).style.setProperty('--jb-menu-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
  }
  function close(returnFocus) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!active) return;
    const old = active; active = null;
    button(old).setAttribute('aria-expanded', 'false'); panel(old).hidden = true;
    old.classList.remove('jb-menu-open');
    if (returnFocus) button(old).focus();
  }
  function open(item) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (active !== item) close(false);
    active = item; position(item);
    button(item).setAttribute('aria-expanded', 'true'); panel(item).hidden = false;
    item.classList.add('jb-menu-open');
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const item = event.target.closest('.jb-nav-item');
    if (!item) return;
    clearTimeout(closeTimer);
    if (item.contains(event.relatedTarget)) return;
    clearTimeout(openTimer); openTimer = setTimeout(() => open(item), 100);
  });
  document.addEventListener('pointerout', event => {
    const item = event.target.closest('.jb-nav-item');
    if (!item || item.contains(event.relatedTarget)) return;
    clearTimeout(openTimer);
    closeTimer = setTimeout(() => { if (active === item && !item.contains(document.activeElement)) close(false); }, 160);
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('.jb-menu-toggle');
    if (toggle) {
      const item = toggle.closest('.jb-nav-item');
      if (active === item) close(false); else open(item);
      return;
    }
    if (active && !active.contains(event.target)) close(false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && active) { event.preventDefault(); close(true); return; }
    const item = event.target.closest('.jb-nav-item');
    if (!item || event.target.closest('.jb-menu-panel')) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); open(item);
      const links = panel(item).querySelectorAll('a[href]');
      links[event.key === 'ArrowUp' ? links.length - 1 : 0]?.focus();
    }
  });
  document.addEventListener('focusin', event => { if (active && !active.contains(event.target)) close(false); });
  document.addEventListener('focusout', () => { setTimeout(() => { if (active && !active.contains(document.activeElement) && !active.matches(':hover')) close(false); }, 0); });
  window.addEventListener('resize', () => { if (active) { if (window.innerWidth < 1200) close(false); else position(active); } });
  window.addEventListener('scroll', () => { if (active) close(false); }, {passive:true});
  document.addEventListener('shopify:section:unload', () => close(false));
})();
